import {
  LOADING_PROCESS,
  SEND_PENDINGLIST_FAILED,
  SEND_PENDINGLIST_SUCCESS,
  SEND_PENDINGLIST_NOT_FOUND,
  SEND_PENDINGLIST_INSUFFICIENT_BALANCE
} from "../types";

const initialState = {
  isProcessing: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_PROCESS:
      return {
        ...state,
        isProcessing: true
      };
    case SEND_PENDINGLIST_FAILED:
    case SEND_PENDINGLIST_SUCCESS:
    case SEND_PENDINGLIST_NOT_FOUND:
    case SEND_PENDINGLIST_INSUFFICIENT_BALANCE:
      return { ...state, isProcessing: false };

    default:
      return state;
  }
};
